import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  ticketId: yup.string().required('Please select a ticket for the participant'),
  email: yup.string().email().required('An email address is required'),
  firstName: yup.string().required('A first name is required'),
  lastName: yup.string().required('A last name is required'),
  birthdate: yup.date().max(new Date(), 'Please add a valid past date'),
});
